import { Navigate, useLocation } from "react-router-dom";
import ServiceLandingPage from "@/components/ServiceLandingPage";
import { getLandingPageBySlug } from "@/data/seoContent.mjs";

export default function GeneratedLandingPage() {
  const location = useLocation();
  const page = getLandingPageBySlug(location.pathname);

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return <ServiceLandingPage {...page} />;
}
